export const getMobileSRC = (url) => {
  const splited = url.split('.');
  return `${splited[0]}_m.jpg`
}